const FILER_BASE = "/filer";
const BUCKET = window.location.hostname.split(".")[0];

function filerUrl(path) {
  return `${FILER_BASE}/buckets/${BUCKET}/${path}`;
}

async function filerFetch(path, token, options = {}) {
  const headers = { ...options.headers, Token: token };
  const res = await fetch(filerUrl(path), { ...options, headers });
  if (res.status === 401) throw Object.assign(new Error("Session expired"), { status: 401 });
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  return res;
}

export async function listDirectory(path, token) {
  const res = await filerFetch(path, token, { headers: { Accept: "application/json" } });
  return res.json();
}

export async function uploadFile(path, file, token, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", filerUrl(path));
    xhr.setRequestHeader("Token", token);
    xhr.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100));
    });
    xhr.onload = () => {
      if (xhr.status === 401) reject(Object.assign(new Error("Session expired"), { status: 401 }));
      else if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`Upload failed: ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error("Upload failed"));
    const formData = new FormData();
    formData.append("file", file);
    xhr.send(formData);
  });
}

export async function downloadFile(path, filename, token) {
  const res = await filerFetch(path, token);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function deleteFile(path, token) {
  await filerFetch(path, token, { method: "DELETE" });
}

export async function createFolder(path, token) {
  await filerFetch(path, token, { method: "POST" });
}
